import React from 'react';

import { AnalyticsV2WidgetLoadingState, AnalyticsV2WidgetSize } from '@tdp/modules/apps';

import { AnalyticsContainer } from './AnalyticsContainer';

export interface ISingleWidgetContainer {
  size: AnalyticsV2WidgetSize;
  header: string;
  loadingState: AnalyticsV2WidgetLoadingState;
  widget: React.ReactNode;
  onViewDetails?: () => void,
}

export const SingleWidgetContainer: React.FC<ISingleWidgetContainer> = ({ size, header, widget, loadingState, onViewDetails }) => {
  return <AnalyticsContainer
    status={loadingState}
    size={size}
    header={header}
    children={widget}
    onViewDetails={onViewDetails}
  />
}
